<ng-template [ngIf]="assetFieldObject.length > 0">
  <ng-template ngFor let-formField [ngForOf]="assetFieldObject">
    <ng-template [ngIf]="!['agency', 'plannedDeletionToggle', 'plannedDeletion'].includes(formField.formFieldName) && !formField.hideDetailsView">
      <div [ngSwitch]="formField['fieldType']">
        <div *ngSwitchCase="'dropdown'" class="input-box">
          <div class="dataset-entry flex row items-start my-2" *ngIf="asset[formField['formFieldName']] || (asset.customFields && asset.customFields[formField['formFieldName']])">
            <span class="dataset-entry-label w-2/5 field-label overflow-hidden text-ellipsis">{{ formField['fieldLabel'] }}</span>
            <div class="dataset-entry-value inline-block w-3/5 pl-2" *ngIf="asset[formField['formFieldName']] && !['client', 'brand'].includes(formField.formFieldName)">
              <span>{{ asset[formField['formFieldName']] | optionsLabel: formField['options'] }}</span>
            </div>
            <div class="dataset-entry-value inline-block w-3/5 pl-2" *ngIf="['client', 'brand'].includes(formField.formFieldName)">
              <span>{{ asset[formField?.formFieldName || '']?.name }}</span>
            </div>
            <div class="dataset-entry-value inline-block w-3/5 pl-2" *ngIf="!asset[formField['formFieldName']] && asset.customFields && !['client', 'brand'].includes(formField.formControlName)">
              <span>{{ asset.customFields[formField['formFieldName']] | optionsLabel: formField['options'] }}</span>
            </div>
          </div>
        </div>
        <div *ngSwitchCase="'multiSelectChip'" class="input-box">
          <div
            class="dataset-entry flex row items-start my-2"
            *ngIf="
              (asset[formField['formFieldName']] && asset[formField['formFieldName']].length > 0) ||
              (asset.customFields && asset.customFields[formField['formFieldName']] && asset.customFields[formField['formFieldName']].length > 0)
            "
          >
            <span class="dataset-entry-label w-2/5 field-label overflow-hidden text-ellipsis">{{ formField['fieldLabel'] }}</span>
            <div class="dataset-entry-value inline-block w-3/5 pl-2 break-words" *ngIf="asset.customFields">
              <ng-template ngFor let-multiSelectField let-i="index" [ngForOf]="asset.customFields[formField['formFieldName']]">
                <span>{{ (i > 0 ? ', ' : '') + (multiSelectField | optionsLabel: formField.options) }}</span>
              </ng-template>
            </div>
          </div>
        </div>
        <div *ngSwitchCase="'label'" class="input-box mt-6 mb-4">
          <div class="flex row items-start my-2" *ngIf="showLabelCheck(formField)">
            <h3 class="w-full field-label text-xl inline-block truncate">{{ formField['fieldLabel'] }}</h3>
          </div>
        </div>
        <div *ngSwitchCase="'formArray'" class="input-box">
          <ng-template ngFor let-domain [ngForOf]="assetDomains" let-i="index">
            <div class="border-b-2" [ngClass]="{ 'border-t-2': i === 0 }">
              <ng-template ngFor let-formFieldsGroup [ngForOf]="formField['formFieldGroup']">
                <div *ngIf="!['agency', 'client', 'brand'].includes(formFieldsGroup.formFieldName) && domain[formFieldsGroup['formFieldName']]" class="dataset-entry flex row items-start my-2">
                  <span class="dataset-entry-label w-2/5 field-label overflow-hidden text-ellipsis">{{ formFieldsGroup['fieldLabel'] }}</span>
                  <div class="dataset-entry-value inline-block w-3/5 pl-2">
                    <span>{{ domain[formFieldsGroup['formFieldName']] }}</span>
                  </div>
                </div>
              </ng-template>
            </div>
          </ng-template>
        </div>
        <div *ngSwitchCase="'textarea'" class="input-box">
          <div class="dataset-entry flex row items-start my-2" *ngIf="asset[formField['formFieldName']] || (asset.customFields && asset.customFields[formField['formFieldName']])">
            <span class="dataset-entry-label w-2/5 field-label inline-block overflow-hidden text-ellipsis">{{ formField['fieldLabel'] }}</span>
            <div class="dataset-entry-value inline-block w-3/5 pl-2 break-words align-top">
              <div class="ql-container ql-snow !bg-inherit !border-0 !min-h-[inherit]" *ngIf="asset[formField['formFieldName']]">
                <div class="ql-editor !p-0 !min-h-[inherit] !overflow-y-hidden" [innerHTML]="asset[formField['formFieldName']]"></div>
              </div>
              <div class="ql-container ql-snow !bg-inherit !border-0 !min-h-[inherit]" *ngIf="!asset[formField['formFieldName']] && asset.customFields">
                <div class="ql-editor !p-0 !min-h-[inherit] !overflow-y-hidden" [innerHTML]="asset.customFields[formField['formFieldName']]"></div>
              </div>
            </div>
          </div>
        </div>
        <div *ngSwitchDefault class="input-box">
          <div class="dataset-entry flex row items-start my-2" *ngIf="asset[formField['formFieldName']] || (asset.customFields && asset.customFields[formField['formFieldName']])">
            <span class="dataset-entry-label w-2/5 field-label inline-block overflow-hidden text-ellipsis">{{ formField['fieldLabel'] }}</span>
            <div class="dataset-entry-value inline-block w-3/5 pl-2 break-words align-top">
              <div class="ql-container ql-snow !bg-inherit !border-0 !min-h-[inherit]" *ngIf="asset[formField['formFieldName']]">
                <div class="ql-editor !p-0 !min-h-[inherit] !overflow-y-hidden" [innerHTML]="asset[formField['formFieldName']]"></div>
              </div>
              <div class="ql-container ql-snow !bg-inherit !border-0 !min-h-[inherit]" *ngIf="!asset[formField['formFieldName']] && asset.customFields">
                <div class="ql-editor !p-0 !min-h-[inherit] !overflow-y-hidden" [innerHTML]="asset.customFields[formField['formFieldName']]"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </ng-template>
</ng-template>
